export enum ViewPanelSettingType {
  LAYOUT = 'layout',
  FILTER = 'filter',
  SORT = 'sort',
  FIELDS = 'fields',
  GROUP = 'group',
  OVERVIEW = 'overview',
}

export interface NavigationOptions {
  from?: ViewPanelSettingType;
}

export type ViewSettingConfigurationType =
  | ViewPanelSettingType.LAYOUT
  | ViewPanelSettingType.FILTER
  | ViewPanelSettingType.SORT
  | ViewPanelSettingType.FIELDS
  | ViewPanelSettingType.GROUP;
